import React, { useEffect, useState } from "react"
import { useLocation, useHistory, Link } from "react-router-dom"
import axiosApi from "../../../../core/interceptor/interceptor";
import { config } from "../../../../config";
import TextEditor from "../../../../Util/TextEditor/TextEditor.js";
import backArrow from "../../../../assets/arrow-back.svg";
import { Disclaimer_Type } from "../../../../Util/helper";
import calendar from '../../../../assets/calendar-icon.svg'
import moment from 'moment';
import DatePicker from "react-datepicker";
import './disclaimer.css';

function EditDisclaimer(props) {
  const history = useHistory();
  const search = useLocation().search;
  const disclaimer_id = new URLSearchParams(search).get('id');
  const [disclaimerData, setDisclaimer] = useState({
    type: '',
    disclaimer: '',
    platform: '',
    start_date: '',
    end_date: ''
  });


  useEffect(() => {
    if (disclaimer_id) {
      axiosApi.get(`${config.apiUrl}/disclaimers/edit/${disclaimer_id}`)
        .then((res) => {
          if (res && res.data && res.data.data) {
            setDisclaimer({
              type: res.data.data?.type,
              disclaimer: res.data.data?.disclaimer,
              platform: res.data.data?.platform,
              start_date: res.data.data?.start_date ? moment(res.data.data.start_date, 'YYYY-MM-DD').toDate() : '',
              end_date: res.data.data?.start_date ? moment(res.data.data.end_date, 'YYYY-MM-DD').toDate() : '',
            })
          }
        })
        .catch((err) => {
          console.error(err)
        })
    }
  }, [disclaimer_id]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const {start_date, end_date, ...data} = disclaimerData;
    if (props?.type === 'Notification') {
      data.start_date = disclaimerData.start_date ? moment(disclaimerData.start_date).format('YYYY-MM-DD') : '';
      data.end_date = disclaimerData.end_date ? moment(disclaimerData.end_date).format('YYYY-MM-DD') : '';
    }
    axiosApi.put(`${config.apiUrl}/disclaimers/update/${disclaimer_id}`, data)
      .then((res) => {
        if (res?.data?.status === 'success') {
          history.push(`/admin/settings/${props?.type === 'Disclaimers' ? 'disclaimer' : (props?.type === 'Headlines' ? 'headline' : (props?.type === 'Notification' ? 'notification-banner' : 'policy'))}`)
        }
      })
      .catch((err) => {
        console.error(err)
      });
  }

  const formDataChange = (event) => {
    setDisclaimer((previousData) => ({
      ...previousData,
      disclaimer: event,
    }))
  }

  const handleModalCloseResponse = (resp) => {
    if (resp) {
      setDisclaimer(prevData => ({
        ...prevData,
        [resp.type]: resp.data,
      }));
    }
  }

  return (
    <div className="content-wrapper edit-disclaimer-wrapper">
      <div className="header">
        <Link to={`/admin/settings/${props?.type === 'Disclaimers' ? 'disclaimer' : (props?.type === 'Headlines' ? 'headline' : (props?.type === 'Notification' ? 'notification-banner' : 'policy'))}`}><button className="primary-btn back-btn"><img src={backArrow} alt='' />Back to {props?.type}</button></Link>
        <div className="header-blk">
          <h2>Edit {Disclaimer_Type[disclaimerData.type]} ({disclaimerData?.platform === 'C' ? 'Cleveland' : 'Mulberry'})</h2>
        </div>
      </div>
      <div className="inner-wrapper">
        <form onSubmit={handleSubmit}>
          <TextEditor value={disclaimerData.disclaimer} edit={true} type="sport" name="disclaimer" onChange={(e) => formDataChange(e)} />
          {
            props?.type === 'Notification'
            &&
            <div className="input-blk">
              <div className="input-field">
                <label>Start Date</label>
                <div className="date-blk">
                  <div className="calendar-blk">
                    <img src={calendar} alt='calendar-icon' />
                  </div>
                  <DatePicker
                    placeholderText={'MM/DD/YYYY'}
                    minDate={new Date()}
                    maxDate={disclaimerData.end_date - 1}
                    selected={disclaimerData.start_date}
                    onChange={(date) => handleModalCloseResponse({ type: 'start_date', data: date })}
                  />
                </div>
              </div>
              <div className="input-field">
                <label>End Date</label>
                <div className="date-blk">
                  <div className="calendar-blk">
                    <img src={calendar} alt='calendar-icon' />
                  </div>
                  <DatePicker
                    placeholderText={'MM/DD/YYYY'}
                    minDate={disclaimerData.start_date ? moment(disclaimerData.start_date).add(1, 'days').toDate() : new Date()}
                    selected={disclaimerData.end_date}
                    onChange={(date) => handleModalCloseResponse({ type: 'end_date', data: date })}
                  />
                </div>
              </div>
            </div>
          }
          <button className="search-btn primary-btn" type="submit">Save</button>
        </form>
      </div>
    </div>

  )
}

export default EditDisclaimer